import ErrorPage from 'ContentEditorUI/components/app/ErrorPage';
import { APP_ERRORS } from 'ContentEditorUI/lib/app/constants';
import { jsx as _jsx } from "react/jsx-runtime";
function InpageScriptError() {
  return /*#__PURE__*/_jsx(ErrorPage, {
    appErrorCategory: APP_ERRORS.INPAGE_SCRIPT_ERROR
  });
}
export default InpageScriptError;